export default __webpack_public_path__ + "static/6763-77b7cd5053b6603ae1efa91734578acb.jpg";